import { externalApiService } from "../infrastructure/ExternalApiService";
import { EXTERNAL_API_CONFIG } from "../config/externalApi.config";

/**
 * Test the external API authentication and client fetching
 * Call this from browser console: window.testExternalAPI()
 */
export async function testExternalAPI() {
  console.log("🔍 Testing External API...");
  console.log("📍 Auth URL:", EXTERNAL_API_CONFIG.AUTH_URL);
  console.log("📍 Base URL:", EXTERNAL_API_CONFIG.BASE_URL);
  console.log("📍 Customer Endpoint:", EXTERNAL_API_CONFIG.CUSTOMER_BY_IDENTIFICATION_ENDPOINT);
  console.log("👤 Username:", EXTERNAL_API_CONFIG.USERNAME);
  console.log("---");

  try {
    // Step 1: Test Authentication
    console.log("🔐 Step 1: Testing Authentication...");
    const token = await externalApiService.authenticate();
    console.log("✅ Authentication successful!");
    console.log("🎫 Token:", token);
    console.log("---");

    // Step 2: Test Get Customer by Identification
    console.log("🔍 Step 2: Testing Get Customer by Identification...");
    try {
      const testIdentification = "3563958";
      const testIdentificationType = "CC";

      console.log(`📍 Fetching customer: ${testIdentification} (${testIdentificationType})`);

      const customer = await externalApiService.getCustomerByIdentification(
        testIdentification,
        testIdentificationType
      );

      console.log("✅ Customer fetched successfully!");
      console.log("👤 Customer data:", customer);

      return { success: true, token, customer };
    } catch (customerError) {
      console.error("❌ Error fetching customer:", customerError);
      return { success: false, error: customerError };
    }
  } catch (error) {
    console.error("❌ Test failed:", error);
    return { success: false, error };
  }
}

// Make it available globally for testing
declare global {
  interface Window {
    testExternalAPI: typeof testExternalAPI;
  }
}

// Expose to window
window.testExternalAPI = testExternalAPI;

// Log that it's available
console.log("✅ External API test utility loaded. Run: testExternalAPI()");
